import { Divider } from '@/components/Divider';
import LoadingButton from '@mui/lab/LoadingButton';
import { Box, Tooltip } from '@mui/material';
import { UseFormSetError } from 'react-hook-form';
import { Renter } from '../../utils/types/renter.interface';
import { CoverageRequirementsAlert } from './CoverageRequirementsAlert';
import CoverageSelectionOld from './CoverageSelectionOld';
import { LeaseInformation } from './LeaseInformation';
import { RenterContact } from './RenterContact';
import { ScreeningResults } from './ScreeningResults';
import useRenterInviteForm from './useRenterInviteForm';
import { Alert } from '@/components/Alert';

interface RenterInviteFormProps {
  onSubmit: (values: Renter, setError: UseFormSetError<Renter>) => void;
  errorMsg: string;
  customCoverageDisabled: boolean;
}

const RenterInviteForm = ({
  onSubmit,
  errorMsg,
  customCoverageDisabled,
}: RenterInviteFormProps) => {
  const {
    handleSubmit,
    watch,
    control,
    trigger,
    setError,
    setValue,
    formState: { isSubmitting, isValid, errors },
  } = useRenterInviteForm({
    customCoverageDisabled,
  });

  return (
    <form
      id="renter-invite-form"
      onSubmit={handleSubmit((values) => onSubmit(values, setError))}
      noValidate
    >
      {customCoverageDisabled && <CoverageRequirementsAlert />}
      <RenterContact control={control} errors={errors} watch={watch} />
      <Divider />
      <LeaseInformation
        control={control}
        errors={errors}
        watch={watch}
        setValue={setValue}
        trigger={trigger}
        isSmbInvites={false}
      />
      <Divider />
      <ScreeningResults
        control={control}
        errors={errors}
        watch={watch}
        setValue={setValue}
        isSmbInvites={false}
      />
      {!customCoverageDisabled && (
        <>
          <Divider />
          <CoverageSelectionOld control={control} errors={errors} watch={watch} />
        </>
      )}
      <Box sx={{ width: '100%', marginTop: 4 }}>
        {errorMsg && (
          <Alert severity="error" sx={{ marginY: 2 }}>
            {errorMsg}
          </Alert>
        )}
        <Tooltip title={!isValid ? 'Please complete the required fields to proceed' : ''}>
          <Box sx={{ display: { xs: 'inherit', sm: 'inline-block' } }}>
            <LoadingButton
              variant="contained"
              type={!isValid || isSubmitting ? 'button' : 'submit'}
              disabled={!isValid || isSubmitting}
              loading={isSubmitting}
              id="RenterInviteSubmitButton"
            >
              Send Invite
            </LoadingButton>
          </Box>
        </Tooltip>
      </Box>
    </form>
  );
};

export default RenterInviteForm;
